module.exports = __webpack_public_path__ + "static/media/asUSDC.5f40f5c5.png";